import Vue from "vue";
import VueRouter from "vue-router";
import authGuard from "../services/authGaurd";
import UserProfile from "@/views/UserProfile.vue";
import Company from "@/views/Company.vue";
import OnboardUser from "@/views/OnboardUser.vue";
import ResetPassword from "@/views/Pages/Authentication/SignUp/ResetPassword.vue";
import ResetPasswordConfirm from "@/views/Pages/Authentication/SignUp/ResetPasswordConfirm.vue";
import store from "../store";

import DashboardLayout from "../views/Layout/DashboardLayout.vue";
import AuthLoginLayout from "../views/Layout/AuthLoginLayout";
import Login from "../views/Pages/Authentication/SignUp/Login.vue";
import Register from "../views/Pages/Authentication/SignUp/Register.vue";
// Dashboard pages
const SmartHome = () =>
    import ("../views/Dashboard/SmartHome.vue");
const Locations = () =>
    import ("../views/Locations.vue");
const NewLocation = () =>
    import ("../views/NewLocation.vue");
const NewDevices = () =>
    import ("../views/NewDevices.vue");
const LocationDetail = () =>
    import ("../views/LocationDetail.vue");
const SensorDetail = () =>
    import ("../views/SensorDetail.vue");
const AlertDetail = () =>
    import ("../views/AlertDetail.vue");
const Test = () =>
    import ("../views/Test.vue");
const DeviceDetail = () =>
    import ("../views/DeviceDetail.vue");
const AlertHistory = () =>
    import ("../views/AlertHistory.vue");
const Automotive = () =>
    import ("../views/Dashboard/Automotive.vue");
const Data = () =>
    import ("../views/Data.vue");
const Staging = () =>
    import ("../views/Staging.vue");
const OOE = () =>
    import ("../views/OOE.vue");
const CustomDashboard = () =>
    import ("../views/CustomDashboard.vue");
const DashboardList = () =>
    import ("../views/DashboardList.vue");
const MapboxTest = () =>
    import ("../views/MapboxTest.vue");
const CommandCenter = () =>
    import ("../views/CommandCenter.vue");

Vue.use(VueRouter);

const routes = [{
        path: "/dashboard",
        name: "Dashboard",
        redirect: "/dashboard",
        component: DashboardLayout,
        beforeEnter: authGuard,
        children: [{
                path: "/dashboard",
                name: "Dashboard",
                component: SmartHome,
            },
            {
                path: "/locations",
                name: "Locations",
                component: Locations,
            },
            {
                path: "/location/:id",
                name: "Location Detail",
                component: LocationDetail,
            },
            {
                path: "/sensor/:sensorId",
                name: "Location Sensor",
                component: SensorDetail,
            },
            {
                path: "/location/:id/device/:sensorId",
                name: "Device Detail",
                component: DeviceDetail,
            },
            {
                path: "/device/:deviceId/alerts",
                name: "Alert History",
                component: AlertHistory,
            },
            {
                path: "/location/:id/sensor/:sensorId/alert/:alertId",
                name: "Location Sensor Alert",
                component: AlertDetail,
            },
            {
                path: "/add-location",
                name: "Add Location",
                component: NewLocation,
            },
            {
                path: "/location/:id/add-device",
                name: "Add Device",
                component: NewDevices,
            },
            {
                path: "/test",
                name: "Test",
                component: Test,
            },
            {
                path: "/mapbox-test",
                name: "Mapbox Test",
                component: MapboxTest,
            },
            {
                path: "/automotive",
                name: "Automotive",
                component: Automotive,
            },
            {
                path: "/profile",
                name: "UserProfile",
                component: UserProfile,
            },
            {
                path: "/company",
                name: "Company",
                component: Company,
            },
            {
                path: "/data",
                name: "data",
                component: Data,
            },
            {
                path: "/staging",
                name: "Staging",
                component: Staging,
            },
            {
                path: "/ooe",
                name: "OOE",
                component: OOE,
            },
            {
                path: "/reports",
                name: "Reports",
                component: DashboardList,
            },
            {
                path: "/reports/:dashboardId",
                name: "CustomDashboard",
                component: CustomDashboard,
                props: true,
            },
            {
                path: "/command",
                name: "Command Center",
                component: CommandCenter,
            },
        ],
    },
    {
        path: "/",
        name: "Authentication",
        redirect: "/",
        component: AuthLoginLayout,
        children: [{
                path: "/",
                name: "Default",
                component: Login,
                meta: {
                    groupName: "Auth",
                },
            },
            {
                path: "/register",
                name: "Default",
                component: Register,
                meta: {
                    groupName: "Auth",
                },
            },
            {
                path: "/onboard",
                name: "OnboardUser",
                component: OnboardUser,
                meta: {
                    groupName: "Auth",
                },
            },
            {
                path: "/reset-password",
                name: "ResetPassword",
                component: ResetPassword,
                meta: {
                    groupName: "Auth",
                },
            },
            {
                path: "/reset-password-confirm",
                name: "ResetPasswordConfirm",
                component: ResetPasswordConfirm,
                meta: {
                    groupName: "Auth",
                },
            },
        ],
    },
    // {
    //   path: "/",
    //   name: "home",
    //   component: SmartHome,
    // },
    // {
    //   path: "/auth",
    //   name: "Authentication",
    //   component: function () {
    //     return import(
    //       /* webpackChunkName: "about" */ "../views/Pages/Authentication/SignUp/Login.vue"
    //     );
    //   },
    // },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

// Navigation guard to check authentication
router.beforeEach((to, from, next) => {
    const isAuthenticated = true; //store.getters.isAuthenticated;

    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next({
                path: "/locations",
                query: { redirect: to.fullPath },
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;